import { PERMISSIONS } from '@tempo-io/permissions';
import { defineNotificationCategory, extractRelativeActionUrl } from './types';

export const feedbackDescriptor = defineNotificationCategory('feedback', {
  actionUrl: (data) => extractRelativeActionUrl(data.actionUrl),
  pills: (data) => [data.feedbackFormName, 'Feedback'],
  audience: PERMISSIONS.VIEW_DEMAND,
  scope: 'entity',
  defaultChannels: ['email', 'in_app', 'slack'],
});

export const ideaCommentsDescriptor = defineNotificationCategory('idea_comments', {
  actionUrl: (data) => extractRelativeActionUrl(data.actionUrl),
  pills: () => ['Comments'],
  audience: PERMISSIONS.VIEW_DEMAND,
  scope: 'entity',
  defaultChannels: ['email', 'in_app', 'slack'],
});

export const commentMentionDescriptor = defineNotificationCategory('comment_mention', {
  actionUrl: (data) => extractRelativeActionUrl(data.actionUrl),
  pills: () => ['Mention'],
  audience: PERMISSIONS.VIEW_DEMAND,
  scope: 'entity',
  defaultChannels: ['email', 'in_app', 'slack'],
});

export const staleIdeasDescriptor = defineNotificationCategory('stale_ideas', {
  actionUrl: (data) => extractRelativeActionUrl(data.actionUrl),
  pills: () => ['Planning'],
  audience: PERMISSIONS.VIEW_DEMAND,
  scope: 'entity',
  defaultChannels: ['email', 'in_app', 'slack'],
});
